const styles = () => ({
  notificationSuccess: {
    flexWrap: 'nowrap',
  },
  notificationError: {
    flexWrap: 'nowrap',
  },
  notificationWarning: {
    flexWrap: 'nowrap',
  },
  notificationInfo: {
    flexWrap: 'nowrap',
  },
});

export default styles;
